import { render, staticRenderFns } from "./DeleteStrategy.vue?vue&type=template&id=6e3593a7&scoped=true"
import script from "./DeleteStrategy.vue?vue&type=script&lang=js"
export * from "./DeleteStrategy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3593a7",
  null
  
)

export default component.exports